export const cdxAnalyticsEventTarget = new EventTarget()
